import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux';
import { goToPage, stepParams, getEquipmentForProduct } from '../../DisconnectServiceSlice'
import './DisconnectProductsPage'
import images from '../../DisconnectPhotos/images'
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Config from '../../../../../Config'
import PopUp from '../../../../Shared/Popup/PopUp'
import { showAppLoader, hideAppLoader } from '../../../../Shared/Loader/LoaderSlice';
import { Container, Row } from 'reactstrap'
import gaParams from '../../../../../utilities/analytics/constants';
import { gaEvent } from '../../../../../utilities/analytics/tracking';
import useExtendedEffect from '../../../../../utilities/hooks/useExtendedEffect';

function DisconnectProductsPage(props) {

    const [isShow, setIsShow] = useState(false);
    const [displayText, SetDisplayText] = useState(false);
    const [displayItem, SetDisplayItem] = useState(null);

    useEffect(() => {
        if(displayItem != null) {
            setIsShow(true);
        }
    },[displayItem])

    useEffect(() => {
        if (typeof window.scrollTo === "function") { 
            window.scrollTo(0, 0);
        } 
        gaEvent(gaParams.DISCONNECT_ENTER_PRODUCT_PAGE.category, gaParams.DISCONNECT_ENTER_PRODUCT_PAGE.eventType, props.serviceToDisconnect.serviceType);
      }, [])

    function closePopUp() {
        setIsShow(!isShow);
    }

    function popUpItem() {
         gaEvent(gaParams.DISCONNECT_CLICK_SHOW_PRODUCT.category, gaParams.DISCONNECT_CLICK_SHOW_PRODUCT.eventType, props.serviceToDisconnect.serviceType);
        return (
            <>
                {displayItem && <Image className="img-big" alt="equipment" src={Config.epiBaseUrl + displayItem.pic} />}
                {displayItem &&<p style={{marginTop: '10px'}}>{displayItem.title}</p>}
            </>
        )
    }

    function getKits(kit) {
        let kitProducts = [];
        let price = 0;
        if(kit.kitProducts && kit.kitProducts.length > 0) {
            kitProducts = kit.kitProducts.map(function(kitProduct, index){
                let equipment = (props.equipmentList || []).find(function(equ){
                    return equ.id.value === kitProduct.productId
                })
                price = kitProduct.price;
                if(equipment) {
                    // Take image
                    const displayPrice = '₪' + kitProduct.price
                    return (
                    <div key={index} className="equipmentBox">
                        <div className="equipmentDetails">
                            <div className="eq-details">
                                {kitProduct.title != "" ? <div className="equipmentTitle">{kitProduct.title}</div> : <div className="equipmentTitle">{equipment.description.value}</div>}
                                {Number(price) > 0 ? <div className="eqPrice">עלות אי-החזרה: {displayPrice}</div> : null }
                            </div>
                            <Image onClick={() => SetDisplayItem({title: equipment.description.value, pic: equipment.photoBig.value.url})} className="img" alt="equipment" src={Config.epiBaseUrl + equipment.photoSmall.value.url} />
                            <Image className="small-arrow-pic" alt="small-arrow" src={images.expandArrowPurple} />
                            <PopUp showPopUp={isShow} onClose={closePopUp}>
                                {popUpItem()}
                            </PopUp>
                        </div>
                    </div> )  
                }
                else {
                    //TBD - Add default img
                    const displayPrice = '₪' + kitProduct.price
                    return (
                        <div key={index} className="equipmentBox">
                            <div className="equipmentDetails">
                            <div className="eq-details">
                                <div className="equipmentTitle">{kitProduct.title}</div>
                                {Number(price) > 0 ? <div className="eqPrice">עלות אי-החזרה: {displayPrice}</div> : null }
                            </div>
                                <Image alt="not found" src={images.default} onClick={() => SetDisplayItem({title: '' , pic: images.default})} className="img" /> 
                                <Image className="small-arrow-pic" alt="small-arrow" src={images.expandArrowPurple} />
                                <PopUp showPopUp={isShow} onClose={closePopUp}>
                                    {popUpItem()}
                                </PopUp>
                            </div>
                        </div> )  
                }
            })
        }        
        return kitProducts
    }

    useEffect(() => {
        async function getProducts() {
           props.showAppLoader();
           await props.getEquipmentForProduct(props.serviceToDisconnect.productId);
           SetDisplayText(true);
           props.hideAppLoader();
        }
        getProducts();
    }, [])

    useEffect(() => {
        if(props.equipmentForProductData.returnDay && props.equipmentForProductData.returnDay != "") {
            props.hideAppLoader();
            SetDisplayText(true);
        }
    },[props.equipmentForProductData.returnDay])

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if(props.equipmentForProductData.kitList && props.equipmentForProductData.kitList.length == 0) {
                props.goToPage({ page: 'SELF_PRODUCT_RETURN_PAGE', params: { ...stepParams, hideHeader: false } })
            }
        }
    }, [props.equipmentForProductData.kitList]);

    useExtendedEffect((runSideEffects) => {
        if (runSideEffects()) {
            if(props.getEquipmentFatalError === true) {
                props.goToPage({ page: 'GET_BACK_TO_YOU_BY_NUMBER', params: { ...stepParams, hideHeader: false } })
            }
        }
    }, [props.getEquipmentFatalError]);
    
    const kits = props.equipmentForProductData.kitList && props.equipmentForProductData.kitList.length > 0 && props.equipmentForProductData.kitList.map(function(kit, index){
        return <Row key={index} className="equipment-row">
                <div className="equipment-info-header">{kit.counter > 1 ? `${kit.counter} ${kit.kitTitle}`: `${kit.kitTitle}`}
                <br />
                {kit.counter > 1 ? <span className="span-txt">עבור כל אחד יש להחזיר: </span> : <span className="span-txt">עבורו יש להחזיר: </span>}
                </div>
            {getKits(kit)}
            </Row>
    })

    function RedirectAndReportGA(){
        gaEvent(gaParams.DISCONNECT_CLICK_CONTINUE_PRODUCTS_PAGE.category, gaParams.DISCONNECT_CLICK_CONTINUE_PRODUCTS_PAGE.eventType, props.serviceToDisconnect.serviceType);
        props.goToPage({ page: 'DELIVERY_PRODUCTS_PAGE', params: { ...stepParams, hideHeader: false } })
    }
    
    return (
        <>
        {displayText ? 
        <Container className="DisconnectProductsPage-root">
            <Row className="header-row">
                <h3 className="header">רשימת הציוד להחזרה</h3>
            </Row>
            {kits}
            <Row className="info-row">
                <div className="info">
                    <Image className="img-info" src={images.infoIconPurple} alt="warning" />
                    <div className="txt">לתשומך ליבך, התאריך האחרון להחזרת הציוד הוא {props.equipmentForProductData.returnDay}.<br /> אי החזרת הציוד במועד תהיה כרוכה בתשלום העלות שלו.</div>
                </div>
            </Row>
            <div className="btn-proceed">
                <BtnSubmit text="המשך" onclick={() => RedirectAndReportGA()}/>    
            </div>
        </Container> : null}
        </>
    )
}

const mapStateToProps = (state) => ({
    stepParams: state.disconnectServicesBlock.stepParams,
    serviceToDisconnect: state.disconnectServicesBlock.serviceToDisconnect,
    equipmentForProductData: state.disconnectServicesBlock.equipmentForProductData,
    getEquipmentFatalError: state.disconnectServicesBlock.getEquipmentFatalError
});
  
const mapDispatchToProps = {
    goToPage,
    getEquipmentForProduct,
    showAppLoader,
    hideAppLoader
};

export default connect(mapStateToProps, mapDispatchToProps)(DisconnectProductsPage);